// Merge helper — folds legacy `tierResourcing` rows into the merged
// `allocations` array as TBD-tier rows. Called when the project form
// opens, when the admin Projects table computes profitability, and
// anywhere the two lists used to be summed side-by-side.
//
// Rules:
//   - Named-person allocation rows carry through unchanged.
//   - Each `tierResourcing` row becomes an allocation row with
//     personId="tbd_migrated_{tier}_{idx}", tbd=true, tier=<row.tier>,
//     load=<row.load>, chargeType="monthly", status="approved"
//     (legacy rows counted in capacity plans, so preserve that).
//   - approvedValues mirrored to load so the capacity matrix keeps reading
//     them (matching existing convention on approved named rows).
//   - If a project has NEITHER allocations nor tierResourcing, an empty
//     array is returned.
export function mergedAllocations(project) {
  const named = project?.allocations || [];
  const legacy = project?.tierResourcing || [];
  if (!legacy.length) return named;
  const migrated = legacy.map((r, idx) => ({
    personId: `tbd_migrated_${(r.tier || "tier").toLowerCase().replace(/\s+/g, "_")}_${idx}`,
    tbd: true,
    tier: r.tier,
    load: { ...(r.load || {}) },
    approvedValues: { ...(r.load || {}) },
    chargeType: "monthly",
    status: "approved",
    migratedFromTierResourcing: true,
    tierResourcingId: r.id,
  }));
  return [...named, ...migrated];
}
